import React from 'react';

import { Helpers } from '../../core/src/helpers';
import ProductPrice from '../../product/components/product-price';
import PurchaseButtonContainer from '../../product/components/purchase-button-container';
import CompareModal from './compare-modal';
import WithCompare from './compare-container';
import { ModalControl } from '../../context/modal/modal-context';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';

import '../css/compare.less';

const BUTTON_BAR_TOGGLE = 1024;

class ProductCompare extends React.Component {
    static getDerivedStateFromProps(props, state) {
        if (props.compareResults) {
            return ProductCompare.updateCompareArray(props.compareResults);
        }
        return null;
    }

    static updateCompareArray(results) {
        let compareResults = [];
        const htmlRegex = new RegExp('(<([^>]+)>)', 'gi');
        results.forEach(spec => {
            let specTitles = [];
            let specValues = [];
            spec.specs.forEach((_, i) => {
                specTitles.push(
                    <div className="compare-cell" key={i}>
                        {spec.title}
                    </div>
                );
            });
            spec.specs.forEach((pSpec, i) => {
                const specValue = pSpec.value.constructor === Array ? pSpec.value.join(', ') : pSpec.value;
                specValues.push(
                    <div className="compare-cell" key={i} dangerouslySetInnerHTML={Helpers.createMarkup(specValue)} />
                );
            });
            compareResults.push(specTitles);
            compareResults.push(specValues);
        });
        return { resultsArray: compareResults };
    }

    constructor(props) {
        super(props);
        this.state = { resultsArray: [] };
    }

    componentDidMount() {
        const { isActiveTab, leftMenuTabCount } = this.props;
        if (typeof isActiveTab === 'boolean' && isActiveTab && leftMenuTabCount === 1) {
            this.checkLeftMenuState();
        }
    }

    componentDidUpdate(prevProps) {
        const { toggleCompareModal, mobileModalOpen } = this.props;
        this.checkLeftMenuState(prevProps);
        if (prevProps.mobileModalOpen !== mobileModalOpen) {
            mobileModalOpen ? toggleCompareModal(true) : toggleCompareModal(false);
        }
    }

    checkLeftMenuState = prevProps => {
        if (typeof window !== 'undefined') {
            const isMobile = window.innerWidth <= BUTTON_BAR_TOGGLE;
            const { setVisibility, compareProducts, setActiveTab, leftMenuTabCount } = this.props;
            const isCompareVisible = isMobile ? compareProducts.length > 1 : compareProducts.length > 0;
            //dont do anything if compare state hasn't changed
            if (prevProps) {
                const { compareProducts: prevCompareProducts } = prevProps;
                const prevCompareVisible = isMobile ? prevCompareProducts.length > 1 : prevCompareProducts.length > 0;
                if (isCompareVisible === prevCompareVisible && prevProps.leftMenuTabCount === leftMenuTabCount) {
                    return;
                }
            }

            //if component is being used in the left menu
            if (setVisibility && setActiveTab) {
                setVisibility(isCompareVisible);
                if (isCompareVisible) {
                    setActiveTab('Compare');
                }
            }
        }
    };

    removeItem(product) {
        return () => {
            this.props.toggleCompareProduct(product);
        };
    }

    generateCompareList(showPrice) {
        let compareList = [];
        for (let i = 0; i < 4; i++) {
            let compareItem;
            if (this.props.compareProducts[i]) {
                let product = this.props.compareProducts[i];
                let [prdImage = {}] = product.images || [];
                let primaryImage = product.defaultImages
                    ? prdImage.altImages[product.defaultImages - 1].lrg
                    : prdImage.cdn;
                compareItem = (
                    <div className="compare-item" key={i}>
                        <span className="x-button" onClick={this.removeItem(product)}></span>
                        <ImageWithPlaceholder src={Helpers.getCDNUrl(primaryImage, product.imageUrl, 300)} />
                        <div className="compare-item-name">{product.name}</div>
                        {showPrice && <ProductPrice product={product} />}
                        {showPrice && <PurchaseButtonContainer product={product} />}
                    </div>
                );
            } else {
                compareItem = (
                    <div className="compare-item empty-item" key={i}>
                        <div className="compare-no-item" onClick={showPrice ? () => this.props.closeModal() : null}>
                            Add product to compare
                        </div>
                    </div>
                );
            }
            compareList[i] = compareItem;
        }
        return compareList;
    }

    compareButton(position) {
        const { closeModal } = this.props;
        return (
            <ModalControl content={CompareModal} contentProps={{ ...this.props }} dynamicContent={true}>
                {props =>
                    this.props.compareProducts.length > 1 ? (
                        <span
                            className={`compare-btn ${position}`}
                            onClick={() => {
                                props.openModal();
                                closeModal && closeModal();
                            }}
                        >
                            COMPARE
                        </span>
                    ) : (
                        <span className={`compare-btn disabled ${position}`}>
                            Select at least 2 products for compare
                        </span>
                    )
                }
            </ModalControl>
        );
    }

    render() {
        return (
            <div className="compare-inner">
                <div className="clearfix">
                    {this.compareButton('left')}
                    <button
                        aria-label="Clear Compare"
                        className="clear-compare unstyled"
                        onClick={this.props.clearCompareProducts}
                    >
                        Clear all
                    </button>
                </div>
                <div className="compare-list">{this.generateCompareList()}</div>
                <div className="compare-bot">{this.compareButton('bottom')}</div>
            </div>
        );
    }
}

export default WithCompare(ProductCompare);
